import api from "./api-utils";
import { Temporal } from "@js-temporal/polyfill";
import { RCA_LIST_RESULTS_LIMIT } from "@/constants/rca-constants.js";
import { DAYS_30_IN_HOURS } from "@/lib/datetime-utils.js";

/**
 * @param {string|number} assetId
 * @param {string} reportingDateUtcIso - shutdown reporting time; sent as UTC ISO string
 * @returns {Promise<{ uniqueId: number, reportingDate: string, message: string }[]>}
 */
export const get30DayRunstatusAlarmHistoryForAsset = async (
  assetId,
  reportingDateUtcIso
) => {
  const newestUtcIso = new Date(reportingDateUtcIso).toISOString();
  const oldestUtcIso = Temporal.Instant.from(newestUtcIso)
    .subtract(DAYS_30_IN_HOURS)
    .toString({ smallestUnit: "millisecond" });

  const { data } = await api.post("/api/alarms/find-alarms", {
    AssetIdentifier: Number(assetId),
    NewestReportingDate: newestUtcIso,
    OldestReportingDate: oldestUtcIso,
    ResultLimit: RCA_LIST_RESULTS_LIMIT,
  });

  const rows = Array.isArray(data) ? data : [];
  return rows.map((r) => {
    const d = new Date(r.ReportingDate ?? r.reportingDate ?? 0);
    return {
      uniqueId: Number(r.UniqueId ?? r.uniqueId ?? 0) || 0,
      reportingDate: Number.isNaN(d.getTime())
        ? new Date(0).toISOString()
        : d.toISOString(),
      message: String(r.Description ?? ""),
    };
  });
};
